import SnackbarUtils from "./SnackbarUtils";

export default class Notibar {
  public static success = (msg) => {
    SnackbarUtils.success(msg);
  };

  public static info = (info, additional?) => {
    SnackbarUtils.info(info);
  };

  public static toast = (msg) => {
    SnackbarUtils.toast(msg);
  };

  public static warn = (msg) => {
    SnackbarUtils.warning(msg);
  };

  public static error = (err, customMessage?) => {
    let msg;
    if (err.message ?? err.Message) {
      msg = err.message ?? err.Message;
    } else if (typeof err === "string") {
      msg = err;
    } else {
      msg = "something went wrong";
    }
    SnackbarUtils.error(customMessage ?? msg);
    return msg;
  };
}
